interface StatCardProps {
  label: string;
  value: string | number;
  previousValue?: string | number;
  suffix?: string;
}

function formatDelta(current: number, previous: number): { text: string; positive: boolean } | null {
  if (previous === 0) return current > 0 ? { text: 'neu', positive: true } : null;
  const delta = ((current - previous) / previous) * 100;
  if (Math.abs(delta) < 0.5) return null;
  return { text: `${delta > 0 ? '+' : ''}${delta.toFixed(0)}%`, positive: delta >= 0 };
}

export function StatCard({ label, value, previousValue, suffix }: StatCardProps) {
  const numericValue = typeof value === 'number' ? value : null;
  const numericPrevious = typeof previousValue === 'number' ? previousValue : null;
  const delta = numericValue !== null && numericPrevious !== null ? formatDelta(numericValue, numericPrevious) : null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{label}</p>
      <div className="mt-2 flex items-baseline gap-2">
        <span className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">
          {value}
          {suffix}
        </span>
        {delta && (
          <span className={`text-xs font-medium ${delta.positive ? 'text-emerald-500' : 'text-rose-500'}`}>
            {delta.text}
          </span>
        )}
      </div>
      {previousValue !== undefined && (
        <p className="mt-1 text-xs text-slate-400 dark:text-slate-500">
          gestern: {previousValue}
          {suffix}
        </p>
      )}
    </div>
  );
}
